import React from "react";
import { useFormContext } from "react-hook-form";
import { FormRichTextField } from "../../fields/basic/RichTextField";
import { GetTimestampAsDateTimeString } from "../../../../common/PrimitiveUtils";
import FormTextField from "../../fields/basic/TextField";
import { Alert } from "@mui/material";
import { useFormHandlerContext } from "../../../../controllers/formController";
import FormStatusSelectionField from "../status/StatusSelectionField";
import { entityStatusConfigs } from "../status/utils";

const FormFooter: React.FC = () => {
  const { getValues } = useFormContext();
  const { globalError } = useFormHandlerContext();

  const fieldExists = (fieldName: string): boolean =>
    getValues().hasOwnProperty(fieldName) && getValues()[fieldName];

  return (
    <>
      <FormRichTextField name="notes" label="Notes" placeholder="Enter notes" />
      <FormRichTextField
        name="internal_notes"
        label="Internal Notes"
        placeholder="Enter internal notes"
      />
      {fieldExists("entity_status_of_proofreading") ? (
        <FormStatusSelectionField
          name="entity_status_of_proofreading"
          label="Proofreading Status"
          options={Object.entries(entityStatusConfigs).map(([key, props]) => ({
            value: key,
            ...props,
          }))}
        />
      ) : null}
      {fieldExists("modified_at") ? (
        <>
          <FormTextField
            name="modified_at"
            label="Updated At"
            textParser={GetTimestampAsDateTimeString}
            placeholder="N/A"
            static
          />
          <FormTextField
            name="modified_by"
            label="Updated By"
            placeholder="N/A"
            static
          />
        </>
      ) : fieldExists("created_at") ? (
        <>
          <FormTextField
            name="created_at"
            label="Created At"
            textParser={GetTimestampAsDateTimeString}
            placeholder="N/A"
            static
          />
          <FormTextField
            name="created_by"
            label="Created By"
            placeholder="N/A"
            static
          />
        </>
      ) : null}
      {globalError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {globalError}
        </Alert>
      )}
    </>
  );
};

export default FormFooter;
